// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610201205/js/" + chunkId + "." + {"44":"f3983224","225":"dc91f425","481":"d301d056","486":"c5e203f1","770":"9e66a0e3"}[chunkId] + ".0.7597306896486125.chunk.js";
};